import { Tenant } from '@/store/modules/app/types'
import { LibraryCategories, LibraryCategory } from '@/store/modules/teamlibrary/types'
import { Namespace } from '@/store/types'
import { Filters } from '@/utils/filters'
import { TenantHelpers } from '@/utils/tenant-helpers'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'

@Component({})
export default class LibraryMixin extends Vue {
  @State('libraryCategories', { namespace: Namespace.TeamLibrary })
  public libraryCategories?: LibraryCategories
  @State('libraryPublicCategories', { namespace: Namespace.TeamLibrary })
  public libraryPublicCategories?: LibraryCategories
  @State('myTenant', { namespace: Namespace.App })
  public myTenant!: Tenant
  @State('initializing', { namespace: Namespace.Utils })
  public initializing!: boolean

  @Action('loadLibraryCategories', { namespace: Namespace.TeamLibrary })
  public loadLibraryCategories: any

  public myTenantID: number = TenantHelpers.InvalidTenantID

  protected created() {
    // Initialize myTenantID from current myTenant state
    if (this.myTenant && this.myTenant.ID) {
      this.myTenantID = this.myTenant.ID
    }
  }

  @Watch('myTenant')
  private onMyTenantChanged(tenant: Tenant) {
    this.myTenantID = tenant.ID
    // Someway to make sure any component using this mixing can run a function after this comment line.
    if (this.initializing) return

    this.onAfterTenantChanged()
  }

  // Hook method that components can override
  protected onAfterTenantChanged(): void {
    // Default implementation does nothing
    // Components using this mixin can override this method
  }

  public get libraryCategoriesMap(): Map<number, LibraryCategory> {
    if (this.libraryCategories != null && this.libraryCategories.Categories != null) {
      return this.categoriesArrayToMap(this.libraryCategories.Categories)
    } else {
      return new Map()
    }
  }

  public get libraryPublicCategoriesMap(): Map<number, LibraryCategory> {
    if (this.libraryPublicCategories != null && this.libraryPublicCategories.Categories != null) {
      return this.categoriesArrayToMap(this.libraryPublicCategories.Categories)
    } else {
      return new Map()
    }
  }

  private get libraryTenantCategoriesArray(): LibraryCategory[] {
    if (this.libraryCategories != null) {
      return this.libraryCategories.Categories
    } else {
      return []
    }
  }

  public categoryIndiciesToCsvString(categoryIndicies: number[], categoriesMap: any): string {
    const tenantCatMap = Filters.categoryIndiciesToCsvString(categoryIndicies, categoriesMap)
    let result = tenantCatMap

    if (result !== '') return result

    if (this.libraryPublicCategoriesMap.size > 0) {
      result = Filters.categoryIndiciesToCsvString(
        categoryIndicies,
        this.libraryPublicCategoriesMap
      )
    }

    return result
  }

  public categoriesArrayToMap(categories: LibraryCategory[]): Map<number, LibraryCategory> {
    return Filters.categoriesArrayToMap(categories)
  }
}
